import TodoCover from "assets/images/todo.png";
import PortfolioCover from "assets/images/portfolio.png";
import BitcoinCover from "assets/images/BTC.png";
import CalcCover from "assets/images/calc.png";
import SeljanCover from "assets/images/seljan.png";
import NobelCover from "assets/images/nobel.png";
import CountryCover from "assets/images/country.png";
import XezanTvCover from "assets/images/xezanTv.png";
import SpaceCover from "assets/images/space.png";


export const portfolioData = [
  {
    cover: TodoCover,
    title: 'Todo List',
    key: 'todo',
    url: 'https://mytodolistwithreact.netlify.app/',
    repo: 'https://github.com/ZuuZaa/todo_react',
    description: [
      'Raect Js',
      'Context API',
      'Theme toogling',
      'Local Storage',
      'Drag & Drop',
    ],
  },
  {
    cover: SpaceCover,
    title: 'Space Tourism',
    key: 'space',
    url: 'https://space-tourism-by-zumrud.netlify.app/',
    repo: 'https://github.com/ZuuZaa/space-tourism',
    description: ['raect', 'styled components', 'sass'],
  },
  {
    cover: CalcCover,
    title: 'Calculator JS',
    key: 'calc',
    url: 'https://calculatewithzumrud.netlify.app/',
    repo: 'https://github.com/ZuuZaa/calculator_js',
    description: ['SCSS', 'JS'],
  },
  {
    cover: XezanTvCover,
    title: 'HR management',
    key: 'hr',
    url: 'https://hr-management-erp.netlify.app',
    repo: 'https://github.com/ZuuZaa/xezan_tv',
    description: ['Raect Js', 'Material UI', 'Redux Saga', 'Formik'],
  },
  {
    cover: SeljanCover,
    title: 'Seljan Nasibli',
    key: 'seljan',
    url: 'https://www.seljannasibli.com/',
    repo: 'https://github.com/ZuuZaa/seljan_nasibli',
    description: ['Bootstrap', 'Jquery', 'Carousel'],
  },
  {
    cover: CountryCover,
    title: 'Countries / in repair',
    key: 'country',
    url: 'https://country-app-by-zumrud.netlify.app/',
    repo: 'https://github.com/ZuuZaa/countries',
    description: ['Raect Js', 'Coindesk API', 'Styled Components'],
  },
  {
    cover: PortfolioCover,
    title: 'Portfolio Page',
    key: 'portfolio',
    url: 'https://zumrudsportfolio.netlify.app/',
    repo: 'https://github.com/ZuuZaa/react-portfolio',
    description: ['Raect Js', 'Emailjs', 'Leaflet Map'],
  },
  {
    cover: NobelCover,
    title: 'NobelElektrik / in repair',
    key: 'nobel',
    url: 'https://nobelelektrik.netlify.app/',
    repo: 'https://github.com/ZuuZaa/nobelelektrik',
    description: ['Bootstrap', 'Jquery', 'Carousel'],
  },
  {
    cover: BitcoinCover,
    title: 'Bitcoin Prices',
    key: 'btc',
    url: 'https://bitcoinrates.netlify.app/',
    repo: 'https://github.com/ZuuZaa/bitcoin_prices_react-redux_coindeskAPI',
    description: ['Raect Js', 'Redux', 'ChartJs', 'Coindesk API'],
  },
]